export default __webpack_public_path__ + "static/media/Gwent-YPMod2-InCourseWorkbook.151cc9f1.pdf";